import { Headline6 } from '@cdm/quickenloans-library/lib';
import { Tooltip } from "@quickenloans-ui-suite/components/atomics"

import { GatsbyImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';
import SocialMediaBar from '../AuthorBioHero/SocialMediaBar';
import * as styles from './AuthorTooltip.module.scss';
import { ariaLabels, testAttributes } from "./Constants";

const AuthorTooltip = ({
    authorImage = '',
    children,
    displayName,
    biography = false,
    socialLinks = [],
    url
}) => 
{
    const content = <div className={styles.authorTooltipContent}>
        {authorImage && (
            <div
                className={styles.authorAvatarContainer}
                data-testid={testAttributes.AUTHOR_TOOLTIP_AVATAR}
            >
                <GatsbyImage
                    layout="fullWidth"
                    alt={`Profile picture of ${displayName}`}
                    image={authorImage}
                    itemProp="image"
                    data-testid={testAttributes.AUTHOR_TOOLTIP_AVATAR_IMAGE}
                />
            </div>
        )}
        {displayName && (
            <div className={styles.authorInfoContainer}>
                <div className={styles.authorInfoDetails}>
                    <div
                        data-testid={testAttributes.AUTHOR_TOOLTIP_NAME}
                    >
                        <Headline6 className="h6_bold">
                            {displayName}
                        </Headline6>
                    </div>
                    {biography && (
                        <div
                            className={styles.authorInfoSection}
                            data-testid={
                                testAttributes.AUTHOR_TOOLTIP_BIOGRAPHY
                            }
                        >
                            {biography}
                        </div>
                    )}
                    <a
                        aria-label={ariaLabels.FULL_BIO_LINK}
                        className={styles.authorTooltipLink}
                        href={url}
                        rel="noreferrer"
                        target="_blank"
                    >
                        Full bio »
                    </a>
                </div>
                {socialLinks.length > 0 && (
                    <div className={styles.authorSocialLinks}>
                        <SocialMediaBar
                            links={socialLinks}
                            testId={testAttributes.AUTHOR_TOOLTIP_SOCIAL}
                        />
                    </div>
                )}
            </div>
        )}
    </div>

    return (
        <Tooltip
            componentsProps={{
                popper: {
                    'className': styles.authorTooltipZIndex
                },
                tooltip: {
                    'data-testid': testAttributes.AUTHOR_TOOLTIP_MAIN_CONTAINER,
                    'className': styles.authorTooltipContainer,
                }
            }}
            content={content}
            disableTouchListener
            placement="bottom"
            size="medium"
        >
            {children}
        </Tooltip>
    );
};

AuthorTooltip.propTypes = {
    /** authorImage, Author's image ( required ) */
    authorImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    /** Author's biography description */
    biography: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
        PropTypes.bool
    ]),
    /** children, component that triggers the tooltip ( required ) */
    children: PropTypes.node.isRequired,
    /** displayName, Author's name ( required ) */
    displayName: PropTypes.string.isRequired,
    /** social, Author's social links ( required ) */
    socialLinks: PropTypes.array,
    /** URL, Author's url profile ( required ) */
    url: PropTypes.string.isRequired,
};

export default AuthorTooltip;